import { render } from "./HeaderEdit.vue?vue&type=template&id=0e07a0a2"
import script from "./HeaderEdit.vue?vue&type=script&lang=js"
export * from "./HeaderEdit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__